import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import type { VillaHostCity } from "../../villa-host.types";
export const CityCard = t0 => {
  const $ = _c(9);
  const {
    city
  } = t0;
  const videoReference = useRef(null);
  const videoPath = `${process.env.NEXT_PUBLIC_BASE_URL_STORE_LANDING}/assets/videos_villa/${city.en}.webm`;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => videoReference.current?.play();
    t2 = () => videoReference.current?.pause();
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== videoPath) {
    t3 = <video ref={videoReference} muted={true} loop={true} playsInline={true} preload="metadata" className="absolute inset-0 size-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100"><source src={videoPath} type="video/webm" /></video>;
    $[2] = videoPath;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== city.fa) {
    t4 = <div className="text-on-surface-high-emphasis relative z-10 transition-opacity group-hover:opacity-0">{city.fa}</div>;
    $[4] = city.fa;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="bg-dim-background group relative flex h-[300px] min-w-60 cursor-pointer items-center justify-center overflow-hidden rounded-3xl" onMouseEnter={t1} onMouseLeave={t2}>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};